<!-- =========================================================================================
  File Name: ECommerceCheckout.vue
  Description: eCommerce Checkout page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="ecommerce-checkout-demo">
        <form-wizard
            ref="checkoutWizard"
            color="rgba(var(--vs-primary), 1)"
            :title="null"
            :subtitle="null"
            :hide-buttons="true">

            <!-- tab 1 content -->
            <tab-content title="CARRITO" icon="feather icon-shopping-cart" class="mb-5">

                <!-- IF CART HAVE ITEMS -->
                <div class="vx-row" v-if="cartItems.length">

                    <!-- LEFT COL -->
                    <div class="vx-col lg:w-2/3 w-full relative">
                        <div class="items-list-view" v-for="(item, index) in cartItems" :key="item.objectID">
                            <item-list-view :item="item" class="mb-base">

                                <!-- SLOT: ITEM META -->
                                <template slot="item-meta">
                                    <h6
                                      class="item-name font-semibold mb-1 cursor-pointer hover:text-primary"
                                      @click="$router.push({name: 'ecommerce-item-detail-view', params: {item_id: item.objectID }}).catch(() => {})">{{ item.nomart }}</h6>
                                    <p class="text-sm mb-2">CÓDIGO <span class="font-semibold cursor-pointer">{{ item.codart }}</span></p>
                                    <p class="text-success text-sm">EN STOCK</p>

                                    <vs-row>
                                      <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                        <p class="mt-4 font-bold text-sm">CANTIDAD</p>
                                      </vs-col>
                                      <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                        <p class="mt-4 font-bold text-sm">P.UNITARIO</p>
                                      </vs-col>
                                      <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                        <p class="mt-4 font-bold text-sm">%DESC</p>
                                      </vs-col>
                                        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                        <p class="mt-4 font-bold text-sm">DESC</p>
                                      </vs-col>
                                    </vs-row>

                                    <vs-row>
                                      <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                        <vs-input-number min="1"  :value="item.quantity" @input="updateItemQuantity($event, index)" class="inline-flex" />
                                      </vs-col>
                                      <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                        {{  lispreShow(item).toFixed(2)  }}
                                      </vs-col>
                                      <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                        {{  descRenShow(item)  }}
                                      </vs-col>
                                        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                        {{  item.valdes.toFixed(2)  }}
                                      </vs-col>
                                    </vs-row>

                                    <!-- <p class="font-medium text-grey mt-4">Delivery by, {{ item.delivery_date }}</p> -->
                                    <!-- <p class="text-success font-medium">{{ item.discount_in_percentage }}% off {{ item.offers_count }} offers Available</p> -->
                                </template>

                                <!-- SLOT: ACTION BUTTONS -->
                                <template slot="action-buttons">

                                    <!-- PRIMARY BUTTON: REMOVE -->
                                    <div class="item-view-primary-action-btn p-3 rounded-lg flex flex-grow items-center justify-center cursor-pointer mb-3" @click="removeItemFromCart(item)">
                                        <feather-icon icon="XIcon" svgClasses="h-4 w-4" />
                                        <span class="text-sm font-semibold ml-2">REMOVER</span>
                                    </div>

                                </template>
                            </item-list-view>
                        </div>
                    </div>

                    <!-- RIGHT COL -->
                    <div class="vx-col lg:w-1/3 w-full">
                        <vx-card>
                            <!-- <p class="text-grey mb-3">Options</p> -->
                            <div class="flex justify-between">
                                <!-- <span class="font-semibold">Coupons</span> -->
                                <span style="margin:auto;"  class="font-medium text-primary cursor-pointer">RESUMEN PEDIDO</span>
                            </div>

                            <vs-divider />

                            <p class="font-semibold mb-3">DETALLE</p>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">SUBTOTAL</span>
                                <span>${{ this.pSubTotal.toFixed(2) }}</span>
                            </div>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">DESCUENTO</span>
                                <span class="text-success">${{ this.pDescuento }}</span>
                            </div>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">GRABA IVA:</span>
                                <span>${{ this.pGrabaIVA.toFixed(2) }}</span>
                            </div>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">NO GRABA IVA:</span>
                                <span>${{ this.pNoGrabaIVA.toFixed(2) }}</span>
                            </div>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">TOTAL NETO</span>
                                <span>${{ this.pTotalNeto.toFixed(2) }}</span>
                            </div>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">I.V.A.</span>
                                <span>${{ this.pIVA.toFixed(2) }}</span>
                            </div>

                            <vs-divider />

                            <div class="flex justify-between font-semibold mb-3">
                                <span>TOTAL</span>
                                <span>${{ this.pTotal.toFixed(2) }}</span>
                            </div>

                            <!-- <vs-button class="w-full" @click="$refs.checkoutWizard.nextTab()">PLACE ORDER</vs-button> -->
                            <vs-button :disabled="generarPedido" class="w-full" @click="armarPedido()">ENVIAR PEDIDO</vs-button>
                        </vx-card>
                    </div>
                </div>

                <!-- IF NO ITEMS IN CART -->
                <vx-card title="NO TIENE NINGÚN PRODUCTO EN SU CARRITO." v-else>
                    <vs-button @click="$router.push('/orders/products').catch(() => {})">CATÁLOGO PRODUCTOS</vs-button>
                </vx-card>

            </tab-content>

            
           <VueElementLoading 
              :active="show1" 
              spinner="bar-fade-scale"  
              :is-full-screen="true"
              text="Enviando Pedido..."
            />

        </form-wizard>
    </div>
</template>

<script>
import Vue from 'vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import axios from "axios";
import auth from '@/auth/authService'
import {mapMutations, mapState, mapActions} from 'vuex'
import moment from 'moment'
import VueElementLoading from 'vue-element-loading'
 
Vue.component('VueElementLoading', VueElementLoading)

const ItemListView = () => import('./components/ItemListView.vue')
var codemp = null
var cliente = null
var lispre = null
var pordes = null
var desart = null
var token = auth.getToken()

export default {
  components: {
    VueElementLoading
  },
  data () {
    return {
      show1: false,
      // TAB 2
      fullName: '',
      mobileNum: '',
      pincode: '',
      houseNum: '',
      area: '',
      landmark: '',
      city: '',
      state: '',
      addressType: 1,
      addressTypeOptions: [
        { text: 'Home', value: 1 },
        { text: 'Office', value: 2 }
      ],
      pSubTotal : 0,
      pDescuento: 0,
      pTotalNeto: 0,
      pGrabaIVA: 0,
      pNoGrabaIVA: 0,
      pIVA: 0,
      pTotal: 0,
      pedido: {},
      generarPedido: false,

      // TAB 3
      paymentMethod: 'debit-card',
      cvv: ''
    }
  },
  computed: {
    ...mapState('eCommerce',['cItemView', 'clientState', 'ruccedState', 'codempState', 'paramState', 'lispreState', 'desartState', 'descliState', 'orderState']),
    cartItems () {
      return this.$store.state.eCommerce.cartItems.slice().reverse()
    },
    isInWishList () {
      return (itemId) => this.$store.getters['eCommerce/isInWishList'](itemId)
    }
  },
  methods: {
    ...mapActions('eCommerce', ['saveOrder', 'recalcular']),
    armarPedido () {
      this.show1 = true;
      var pedidoEC = {};
      pedidoEC = this.pedido;
      pedidoEC.codmon = '01';
      pedidoEC.codemp = codemp;
      pedidoEC.codcli = cliente.codcli;
      pedidoEC.nomcli = cliente.nomcli;
      pedidoEC.rucced = cliente.rucced;
      pedidoEC.dircli = cliente.dircli;
      pedidoEC.lispre = lispre;
      pedidoEC.codven = null;
      pedidoEC.fecfac = moment(new Date()).format('YYYY-MM-DD HH:m:s');
      pedidoEC.fecven = moment(new Date()).format('YYYY-MM-DD');
      pedidoEC.estado = 'P';
      pedidoEC.conpag = 'E';
      pedidoEC.aprobado = 'S';
      pedidoEC.codusu = null;
      pedidoEC.fecult = moment(new Date()).format('YYYY-MM-DD');
      pedidoEC.pordes = pordes;
      pedidoEC.descuen = 0;
      pedidoEC.otrcar = 0;
      pedidoEC.poriva = this.paramState.mv_eiva;
      pedidoEC.descargado = 'N';
      pedidoEC.observ = null;
      pedidoEC.valcot = 1;
      pedidoEC.totbas = 0;
      pedidoEC.totaldesc = 0;
      pedidoEC.totret = 0;
      pedidoEC.estadow = 'D';
      pedidoEC.totfac2 = 0;
      pedidoEC.totiva2 = 0;
      pedidoEC.horaini = moment(new Date()).format('HH:m:s');
      pedidoEC.horafin = moment(new Date()).format('HH:m:s');
      pedidoEC.totint = 0;
      
      pedidoEC.renglones = this.$store.state.eCommerce.cartItems;

      for (var renglon in pedidoEC.renglones){
        var product = pedidoEC.renglones[renglon];
        product.codven = null;
        product.cantid = product.quantity;
        product.preuni = product['prec0'+lispre];
        product.desren = (product['desc'+desart] ? product['desc'+desart] : 0);
        product.coduni1 = product.coduni;
        product.valuni = 1;
        product.multica = 'S';
        product.bienser = 'B';
        product.promo = 'N';
        product.fecult = moment(new Date()).format('YYYY-MM-DD');
        product.codalm = null;
        product.hora = moment(new Date()).format('HH:m:s');
        product.fecfac = moment(new Date()).format('YYYY-MM-DD HH:m:s');

      }

        this.guardarPedido(codemp, cliente.codven, pedidoEC);
        
    },
    guardarPedido(empS, venS, pedS){
      this.generarPedido = true;
      var orderPayload = []
      orderPayload.emp = empS;
      orderPayload.ven = venS;
      orderPayload.ped = pedS;
      orderPayload.token = auth.getToken();
      this.saveOrder(orderPayload).then(
      response => { 
        if(this.orderState.data.success == true){
        this.$vs.notify({
                  title: 'Pedido Guardado',
                  text: 'Pedido generado correctamente',
                  iconPack: 'feather',
                  icon: 'icon-save',
                  color: 'success'
        });
        this.removeAllItemFromCart ();
        this.generarPedido = false;
        this.show1 = false;
        if(this.paramState.ec_whaven && this.paramState.ec_whaven.length > 0){
          this.$router.push( {
              name: 'page-contacts', 
              params: {pedS: pedS, numtra: this.orderState.data.numtra } 
            })
        }else{
          this.$router.push( {
              name: 'ecommerce-shop'
            })
        }
      }else{
        this.generarPedido = true;
        this.show1 = false;
        this.$vs.notify({
                title: 'Error',
                text: 'Problema al generar pedido',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
      }
      }).catch((error) => { console.log(error) })
    },
    recalcularPedido(){
      var recalcularPayload = []
      recalcularPayload.paramS = this.paramState;
      recalcularPayload.lispreS = this.lispreState;
      recalcularPayload.desartS = this.desartState;
      recalcularPayload.pordes =  this.descliState;
      recalcularPayload.rengloneS = this.$store.state.eCommerce.cartItems;
      this.recalcular(recalcularPayload)
      this.pSubTotal = this.$store.state.eCommerce.subTotalState;
      this.pDescuento = this.$store.state.eCommerce.descuentoState;
      this.pTotalNeto = this.$store.state.eCommerce.totalNetoState;
      this.pGrabaIVA = this.$store.state.eCommerce.grabaIvaState;
      this.pNoGrabaIVA = this.$store.state.eCommerce.noGrabaIvaState;
      this.pIVA = this.$store.state.eCommerce.ivaState;
      this.pTotal = this.$store.state.eCommerce.totalState;
      this.pedido = this.$store.state.eCommerce.pedidoState;
    },
    // TAB 1
    removeItemFromCart (item) {
      this.$store.dispatch('eCommerce/toggleItemInCart', item)
      this.recalcularPedido()
    },
    removeAllItemFromCart () {
      var carrito = this.$store.state.eCommerce.cartItems;
      while  (carrito.length !=0) {
        this.removeItemFromCart (carrito[0])
      }
    },
    wishListButtonClicked (item) {
      // Toggle in Wish List
      if (this.isInWishList(item.objectID)) this.$router.push('/apps/eCommerce/wish-list').catch(() => {})
      else {
        this.toggleItemInWishList(item)
        this.removeItemFromCart(item)
      }
    },
    toggleItemInWishList (item) {
      this.$store.dispatch('eCommerce/toggleItemInWishList', item)
    },
    updateItemQuantity (event, index) {
      const itemIndex = Math.abs(index + 1 - this.cartItems.length)
      this.$store.dispatch('eCommerce/updateItemQuantity', { quantity: event, index: itemIndex })
      this.recalcularPedido()
    },
    descRenShow (itemReng){
        var lis = this.lispreState;
        if(lis.toString() === '1'){
            return itemReng.desc1
        }else if (lis.toString() === '2'){
            return itemReng.desc2
        }else if(lis.toString() === '3'){
            return itemReng.desc3
        }else if (lis.toString() === '4'){
            return itemReng.desc4
        }else{
            return itemReng.desc1
        }
    },
    lispreShow (itemReng){
        var lis = this.lispreState;
        if(lis.toString() === '1'){
            return itemReng.prec01
        }else if (lis.toString() === '2'){
            return itemReng.prec02
        }else if(lis.toString() === '3'){
            return itemReng.prec03
        }else if (lis.toString() === '4'){
            return itemReng.prec04
        }else{
            return itemReng.prec01
        }
    },
  },
  created () {
    codemp = this.codempState
    cliente = this.clientState
    lispre = this.lispreState;
    pordes = this.descliState;
    desart = this.desartState;
    this.recalcularPedido()

  },
  components: {
    ItemListView,
    FormWizard,
    TabContent
  }
}
</script>

<style lang="scss" scoped>
#ecommerce-checkout-demo {
    .item-view-primary-action-btn {
        color: #2c2c2c !important;
        background-color: #f6f6f6;
    }

    .item-name {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        -webkit-line-clamp: 2;
    }

    .vue-form-wizard {
        padding-bottom: 0;

        ::v-deep .wizard-header {
            padding: 0;
        }

        ::v-deep .wizard-tab-content {
            padding-right: 0;
            padding-left: 0;
            padding-bottom: 0;

            .wizard-tab-container{
              margin-bottom: 0 !important;
            }
        }
    }
}
</style>
